var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpot = function SvgSpot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19 2.57c1.425 0 2.725.534 3.712 1.412-2.563.322-4.81 1.753-5.905 4.055-.772 1.623-.845 3.417-.342 5.103A5.59 5.59 0 0 1 7.19 2.57M14.4 5.43a8 8 0 1 1 0 16 8 8 0 0 1 0-16m.397 4.898a.427.427 0 0 0-.793 0l-.213.515a3.68 3.68 0 0 1-1.896 1.96l-.605.268a.447.447 0 0 0 0 .812l.64.284c.832.37 1.5 1.046 1.87 1.896l.207.477a.427.427 0 0 0 .787 0l.207-.477a3.68 3.68 0 0 1 1.87-1.896l.64-.284a.447.447 0 0 0 0-.812l-.604-.269a3.68 3.68 0 0 1-1.896-1.96z"
  })));
};
export default SvgSpot;